import { profileApi } from '@reducers/profile/profile';

export function configureProfileQueries({ id }) {
  // Profile
  const [updateQuery, updateResult] = profileApi.useUpdateProfileMutation();
  // End-user Data
  const [addEndUserQuery, addEndUserResult] =
    profileApi.useCreateEndUserDataMutation();
  const [updateEndUserQuery, updateEndUserResult] =
    profileApi.useUpdateEndUserDataMutation();
  // Documents
  const [uploadDocumentsQuery, uploadDocumentsResult] =
    profileApi.useUploadDocumentsMutation();

  return {
    update: {
      query: ({ data }) => updateQuery({ id, data }),
      result: updateResult,
    },
    addEndUser: {
      query: ({ data }) => addEndUserQuery({ id, data }),
      result: addEndUserResult,
    },
    updateEndUser: {
      query: ({ data }) => updateEndUserQuery({ id, data }),
      result: updateEndUserResult,
    },
    uploadDocuments: {
      query: ({ data }) => uploadDocumentsQuery({ id, data }),
      result: uploadDocumentsResult,
    },
  };
}
